const items = [
  "Nach der OLMA ist vor der Hitsstube",
  "Waaghaus · Marktplatz St. Gallen",
  "Freitag & Samstag · 19:00–02:00 Uhr",
];

function BallIcon() {
  return (
    <svg
      viewBox="0 0 16 16"
      aria-hidden="true"
      className="h-4 w-4 shrink-0 sm:h-5 sm:w-5"
    >
      <circle cx="8" cy="8" r="6.6" fill="none" stroke="#F0EAE0" strokeWidth="1.5" />
      <path
        d="M1.4 8h13.2M8 1.4v13.2M3.5 3.7a9 9 0 0 1 0 8.6M12.5 3.7a9 9 0 0 0 0 8.6"
        stroke="#F0EAE0"
        strokeWidth="1.1"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

const Row = ({ hidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {items.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-6 font-display text-lg text-paper sm:px-8 sm:text-xl">
          {t}
        </span>
        <BallIcon />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="marquee"
      className="relative z-10 -mx-2 -rotate-1 overflow-hidden bg-brand-red py-3.5 shadow-none sm:py-4"
    >
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
